import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ArrowBottomRightAngleIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <Path d="M5.17157 13.657H13.6568M13.6568 13.657V5.17169M13.6568 13.657L2.34314 2.34326" stroke={color} strokeLinejoin="round" />
  </Svg>
);

ArrowBottomRightAngleIcon.displayName = 'ArrowBottomRightAngleIcon';
